<template>
  <div class="insights-ia-agent-tabs">
    <F360Tabs
      ref="tabsRef"
      :tabs="tabs"
      :define-tab="tabSelecionada"
      @tab-click="handleTabClick"
    />
  </div>
</template>

<script setup lang="ts">
import F360Tabs from "@/ui/components/Tabs/Tab/F360Tabs.vue";
import { useTypeformCsat } from "@/features/financas/common/useTypeformCsat";
import { nextTick, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const tabSelecionada = ref<string>("dre");
const tabsRef = ref<InstanceType<typeof F360Tabs> | null>(null);

const tabs = [
  {
    name: "dre",
    label: "Agente de DRE"
  },
  {
    name: "fluxo-caixa",
    label: "Agente de Fluxo de caixa (Em breve)"
  }
];

const { openTypeformCsat } = useTypeformCsat();

const handleTabClick = (tab: string) => {
  if (tab === "fluxo-caixa") {
    const abaAnterior = tabsRef.value?.activeTab || tabSelecionada.value || "dre";
    openTypeformCsat("y2e9KmAx");
    nextTick(() => {
      if (tabsRef.value) {
        tabsRef.value.activeTab = abaAnterior;
      }
      tabSelecionada.value = abaAnterior;
    });

    return;
  }

  tabSelecionada.value = tab;
  router.push(`/insights-ia/${tab}`);
};

onMounted(() => {
  const rotaAtual = router.currentRoute.value.path;
  tabSelecionada.value = rotaAtual.includes("fluxo-caixa") ? "fluxo-caixa" : "dre";
});
</script>

<style lang="scss" scoped>
.insights-ia-agent-tabs {
  flex-shrink: 0;
  padding: 0 12px;
  border-radius: 4px;
  margin-top: 7px;
  width: auto;
  background: #fff;
  color: _map.get($map: $neutro, $key: 500);
  font-size: 12px;
}
</style>
